import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { parseAsEstreeExpression } from "./parse";
import { precook } from "./precook";
// `raw` should always be asserted by `isEvaluable`.
export function preevaluate(raw, options) {
  var fixes = [];
  var source = raw.replace(/^\s*<%[~=]?\s|\s%>\s*$/g, m => {
    fixes.push(m);
    return "";
  });
  var expression = parseAsEstreeExpression(source);
  var attemptToVisitGlobals = precook(expression, _objectSpread(_objectSpread({}, options), {}, {
    expressionOnly: true
  }));
  return {
    expression,
    attemptToVisitGlobals,
    source,
    prefix: fixes[0],
    suffix: fixes[1]
  };
}
export function isEvaluable(raw) {
  return /^\s*<%[~=]?\s/.test(raw) && /\s%>\s*$/.test(raw);
}
export function shouldAllowRecursiveEvaluations(raw) {
  return /^\s*<%~\s/.test(raw);
}
export function isTrackAll(raw) {
  return /^\s*<%=\s/.test(raw) && /\s%>\s*$/.test(raw);
}
//# sourceMappingURL=preevaluate.js.map